{
  "name": "@jillen/analytics",
  "version": "4.0.35",
  "description": "Advanced analytics package for Next.js applications with bot detection and comprehensive tracking",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    },
    "./server": {
      "types": "./dist/server.d.ts",
      "import": "./dist/server.mjs",
      "require": "./dist/server.js"
    }
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "clean": "rm -rf dist",
    "prepublishOnly": "npm run clean && npm run build",
    "test": "echo \"Error: no test specified\" && exit 1"
  },
  "keywords": [
    "analytics",
    "nextjs",
    "tracking",
    "bot-detection",
    "web-analytics",
    "typescript"
  ],
  "author": "Jillen",
  "license": "MIT",
  "peerDependencies": {
    "next": ">=13.0.0",
    "react": ">=18.0.0"
  },
  "dependencies": {
    "isbot": "^5.1.31",
    "web-vitals": "^5.1.0"
  },
  "devDependencies": {
    "@types/node": "^20.19.23",
    "@types/react": "^19.2.2",
    "tsup": "^8.5.0",
    "typescript": "^5.9.3"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jillen/analytics.git"
  },
  "bugs": {
    "url": "https://github.com/jillen/analytics/issues"
  },
  "homepage": "https://github.com/jillen/analytics#readme"
}
